
import { LLMInstructionCodeDto } from "../../dto/llm-instructions/lm-instruction.dto";
import { LLMInstructionCode } from "../../models/llm-instruction.model";

export class LLMInstructionCodeMapper {
  public static toModel(dto: LLMInstructionCodeDto): LLMInstructionCode {
    return {
      code: dto.code,
      name: dto.name
    }
  }

  public static toDto(model: LLMInstructionCode): LLMInstructionCodeDto {
    return {
      code: model.code,
      name: model.name
    }
  }
}
